export default function SectionsC() {
  return (
    <>
      {/* ===== #comments ===== */}
      <section id="comments" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">读者评价</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">女神漫画网读者们的真实反馈，看看大家怎么说</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
            {[
              { name: '漫画迷小夏', avatar: '夏', text: '女神漫画网免费看真的太方便了！下拉式阅读超级流畅，比翻页的舒服一百倍，已经推荐给所有朋友了。', rating: 5, tag: '老读者' },
              { name: '追更达人阿杰', avatar: '杰', text: '每天必刷女神漫画网，更新速度快，韩漫日漫国漫都有，好看的免费漫画大全都在这里了。', rating: 5, tag: '忠实用户' },
              { name: '校园漫控琳琳', avatar: '琳', text: '校园恋爱漫画资源超全！女神漫画免费全集在线看体验超棒，手机上看也很流畅，强烈推荐。', rating: 5, tag: '新用户' },
              { name: '夜猫子读者老陈', avatar: '陈', text: '晚上睡前必看女神漫画网，下拉式阅读不用频繁操作，沉浸感很强。希望更新能再快一点就更好了。', rating: 4, tag: '活跃读者' },
              { name: '萌新小白兔', avatar: '兔', text: '刚入坑漫画，朋友推荐的女神漫画网免费看平台，界面简洁没有任何乱七八糟的弹窗，体验满分！', rating: 5, tag: '萌新入坑' },
            ].map((comment, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-5 border border-background-200/70 flex flex-col">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-heading text-primary-500">{comment.avatar}</span>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-700 whitespace-nowrap">{comment.name}</h3>
                    <span className="text-[10px] text-foreground-400">{comment.tag}</span>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-2">
                  {[...Array(5)].map((_, j) => (
                    <i key={j} className={`text-xs ${j < comment.rating ? 'text-accent-400' : 'text-secondary-200'}`}>★</i>
                  ))}
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed flex-1">{comment.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== #updates ===== */}
      <section id="updates" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">最新更新</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">女神漫画网每日漫画更新动态，追更不迷路</p>
          </div>
          <div className="relative pl-8 border-l-2 border-background-200/70 space-y-6">
            {[
              { time: '今天 08:30', title: '《我的女神是校花》第128话更新', desc: '最新话：告白之夜，校花女神的真心话大公开' },
              { time: '今天 07:15', title: '《绝世女帝养成记》第95话上线', desc: '女帝终于登基，朝堂之上的精彩对决拉开序幕' },
              { time: '昨天 20:00', title: '《霸道女神爱上我》第67话发布', desc: '霸道总裁女神的秘密身份曝光，男主震惊不已' },
              { time: '昨天 18:30', title: '《女神降临在我家》第42话更新', desc: '同居生活的新篇章，两人关系迎来微妙变化' },
              { time: '昨天 12:00', title: '《樱花树下的约定》第156话加更', desc: '读者千呼万唤的告白场景终于到来，感动落泪' },
              { time: '前天 20:45', title: '《暗夜女神》第33话新章开启', desc: '深夜追凶，女神探发现惊天秘密，剧情推向高潮' },
              { time: '前天 16:00', title: '《重生之我是漫画女神》第88话更新', desc: '漫画世界中出现神秘新角色，女主命运即将改写' },
              { time: '07月27日', title: '《女神契约者》第51话登场', desc: '最终决战前的平静，伙伴们的羁绊更加深厚' },
              { time: '07月27日', title: '《猫咪与女神》第25话暖心更新', desc: '流浪猫救助行动，温暖治愈的社区故事感动人心' },
            ].map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[33px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  <div className="flex-1">
                    <h3 className="text-sm font-semibold text-foreground-700">{item.title}</h3>
                    <p className="text-xs text-foreground-400 mt-0.5">{item.desc}</p>
                  </div>
                  <span className="text-[10px] px-2 py-0.5 bg-primary-50 text-primary-500 rounded-full whitespace-nowrap self-start sm:self-center">NEW</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== #cards ===== */}
      <section id="cards" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">推荐漫画</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">女神漫画网编辑精选的免费女神漫画全集，总有一部适合你</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            <div className="flex bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="w-28 sm:w-32 flex-shrink-0 overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Elegant%20manga%20cover%20illustration%20with%20beautiful%20anime%20female%20character%20in%20traditional%20Chinese%20dress%2C%20warm%20coral%20and%20gold%20tones%2C%20soft%20cream%20background%2C%20Japanese%20anime%20art%20style%2C%20clean%20composition%2C%20delicate%20linework%2C%20professional%20quality&width=400&height=560&seq=card-01&orientation=portrait" alt="女神漫画网 - 凤还巢" title="女神漫画网免费看 - 凤还巢" className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 p-4 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800">凤还巢</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">古风逆袭漫画，凤凰涅槃重生归来的复仇与爱情故事</p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="text-[10px] px-2 py-0.5 bg-primary-50 text-primary-500 rounded-full whitespace-nowrap">古风</span>
                  <span className="text-[10px] text-foreground-300">连载中 · 89话</span>
                </div>
              </div>
            </div>
            <div className="flex bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="w-28 sm:w-32 flex-shrink-0 overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Romantic%20manga%20cover%20with%20lovely%20school%20girl%20anime%20character%20smiling%2C%20warm%20coral%20pink%20color%20palette%2C%20soft%20cream%20background%2C%20Japanese%20anime%20illustration%20style%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20delicate%20linework&width=400&height=560&seq=card-02&orientation=portrait" alt="女神漫画网 - 星之恋语" title="女神漫画网免费看 - 星之恋语" className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 p-4 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800">星之恋语</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">校园纯爱漫画，天文社少年与神秘转学生的星空下的约定</p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="text-[10px] px-2 py-0.5 bg-primary-50 text-primary-500 rounded-full whitespace-nowrap">校园</span>
                  <span className="text-[10px] text-foreground-300">连载中 · 102话</span>
                </div>
              </div>
            </div>
            <div className="flex bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="w-28 sm:w-32 flex-shrink-0 overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Dynamic%20manga%20cover%20with%20cool%20female%20spy%20character%20in%20modern%20city%20night%2C%20warm%20amber%20streetlights%2C%20Japanese%20anime%20art%20style%2C%20suspenseful%20mood%2C%20cream%20highlight%20accents%2C%20clean%20illustration%2C%20professional%20quality&width=400&height=560&seq=card-03&orientation=portrait" alt="女神漫画网 - 暗影特工" title="女神漫画网免费看 - 暗影特工" className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 p-4 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800">暗影特工</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">现代都市谍战漫画，美女特工的双面人生与惊险任务</p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="text-[10px] px-2 py-0.5 bg-primary-50 text-primary-500 rounded-full whitespace-nowrap">悬疑</span>
                  <span className="text-[10px] text-foreground-300">连载中 · 56话</span>
                </div>
              </div>
            </div>
            <div className="flex bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="w-28 sm:w-32 flex-shrink-0 overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Fantasy%20manga%20cover%20with%20magical%20girl%20character%20surrounded%20by%20sparkles%2C%20warm%20coral%20and%20gold%20magical%20effects%2C%20cream%20background%2C%20Japanese%20anime%20style%2C%20enchanted%20atmosphere%2C%20clean%20composition%2C%20delicate%20linework&width=400&height=560&seq=card-04&orientation=portrait" alt="女神漫画网 - 魔法少女心" title="女神漫画网免费看 - 魔法少女心" className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 p-4 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800">魔法少女心</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">奇幻魔法漫画，平凡少女觉醒魔力成为拯救世界的魔法少女</p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="text-[10px] px-2 py-0.5 bg-primary-50 text-primary-500 rounded-full whitespace-nowrap">奇幻</span>
                  <span className="text-[10px] text-foreground-300">连载中 · 73话</span>
                </div>
              </div>
            </div>
            <div className="flex bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="w-28 sm:w-32 flex-shrink-0 overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Warm%20healing%20manga%20cover%20with%20gentle%20female%20baker%20character%20in%20bakery%20shop%2C%20soft%20coral%20and%20cream%20tones%2C%20cozy%20atmosphere%2C%20Japanese%20anime%20style%2C%20comforting%20slice%20of%20life%2C%20clean%20illustration%2C%20warm%20lighting&width=400&height=560&seq=card-05&orientation=portrait" alt="女神漫画网 - 面包屋女神" title="女神漫画网免费看 - 面包屋女神" className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 p-4 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800">面包屋女神</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">治愈系日常漫画，美女面包师与街坊邻里的温暖故事集</p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="text-[10px] px-2 py-0.5 bg-primary-50 text-primary-500 rounded-full whitespace-nowrap">治愈</span>
                  <span className="text-[10px] text-foreground-300">连载中 · 44话</span>
                </div>
              </div>
            </div>
            <div className="flex bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="w-28 sm:w-32 flex-shrink-0 overflow-hidden bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Action%20manga%20cover%20with%20fierce%20female%20swordsman%20character%20in%20dynamic%20pose%2C%20warm%20coral%20and%20amber%20energy%20effects%2C%20cream%20background%2C%20Japanese%20anime%20style%2C%20intense%20action%2C%20clean%20illustration%2C%20delicate%20linework&width=400&height=560&seq=card-06&orientation=portrait" alt="女神漫画网 - 剑道女神" title="女神漫画网免费看 - 剑道女神" className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 p-4 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800">剑道女神</h3>
                <p className="text-xs text-foreground-400 mt-1 line-clamp-2">热血格斗漫画，少女剑道高手踏上全国大赛征途的燃情故事</p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="text-[10px] px-2 py-0.5 bg-primary-50 text-primary-500 rounded-full whitespace-nowrap">热血</span>
                  <span className="text-[10px] text-foreground-300">连载中 · 61话</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== #features ===== */}
      <section id="features" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">平台特色</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">选择女神漫画网免费看的五大理由</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {[
              { icon: 'ri-book-open-line', title: '海量免费全集', desc: '2000+部女神漫画免费全集在线看，韩漫日漫国漫一应俱全' },
              { icon: 'ri-arrow-down-circle-line', title: '下拉式阅读', desc: '女神漫画免费下拉式流畅阅读体验，无需繁琐翻页沉浸看漫画' },
              { icon: 'ri-smartphone-line', title: '手机完美适配', desc: '无需下载App，浏览器打开即看，自适应屏幕畅享女神漫画网免费看' },
              { icon: 'ri-timer-flash-line', title: '每日同步更新', desc: '热门连载每日更新追更推荐，第一时间获取最新章节更新通知' },
              { icon: 'ri-shield-check-line', title: '安全无广告弹窗', desc: '女神漫画网承诺无恶意弹窗与强制跳转，纯净阅读环境放心看' },
            ].map((feature, i) => (
              <div key={i} className="flex flex-col items-center text-center p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300">
                <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-2xl text-primary-500`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">{feature.title}</h3>
                <p className="text-xs text-foreground-400 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}